// @ts-nocheck
import { getIsAuthenticated } from "@store/Framework/Store/Foundation/Context/ContextSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { getDisplayProductPricesPolicy } from "@store/Framework/Store/Context/ContextSelectors";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";

export const canUserSeePrices = (state: ApplicationState) => {
    const isAuthenticated = getIsAuthenticated(state);
    const currentAccount = getCurrentAccountState(state).value;
    const displayProductPricesPolicy = getDisplayProductPricesPolicy(state);

    if (!displayProductPricesPolicy) {
        return true;
    }

    return isAuthenticated
        ? getBooleanProperty(currentAccount?.properties.canSeePricesPolicy) || currentAccount?.role === "Administrator"
        : true;
};
